<template>
    <div class="animated fadeIn">
        <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
            <div slot="header">
                <i class="icon-note"></i> CVO Detail Activity Visit
            </div>

            <b-card-body>
                <b-form id="employeeForm" validated novalidateF>
                    <div v-if="loading == false">
                        <b-row>
                            <b-col sm="3">
                                <b-form-group label-for="name" label="Nama Outlet">
                                    <b-form-input id="name" type="text" v-model="cvoVisitData.customer_name"
                                        :readonly="true" placeholder="Nama Konsumen"></b-form-input>
                                    <b-form-invalid-feedback>Nama Konsumen harus di isi.</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="3">
                                <b-form-group label-for="cvo-name" label="Nama CVO">
                                    <b-form-input id="cvo-name" type="text" v-model="cvoVisitData.employee_name"
                                        :readonly="true" placeholder="Nama CVO"></b-form-input>
                                    <b-form-invalid-feedback>Nama CVO harus di isi.</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="3">
                                <b-form-group label-for="activity" label="Aktivitas">
                                    <b-form-input id="activity" type="text" v-model="cvoVisitData.activity_name"
                                        :readonly="true" placeholder="Aktivitas"></b-form-input>
                                    <b-form-invalid-feedback>Aktivitas harus di isi.</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                             <b-col sm="3">
                                <b-form-group label-for="activity" label="Tanggal Aktivitas">
                                    <b-form-input id="activity" type="text" v-model="cvoVisitData.date_inserted"
                                        :readonly="true" placeholder="Aktivitas"></b-form-input>
                                    <b-form-invalid-feedback>Aktivitas harus di isi.</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col lg="3">
                                <b-form-group label-for="before_image" label="Foto Sebelum">
                                    <b-img :src="urlAssets + cvoVisitData.before_visit" :thumbnail="true"></b-img>
                                </b-form-group>
                            </b-col>
                            <b-col lg="3">
                                <b-form-group label-for="after_image" label="Foto Setelah">
                                    <b-img :src="urlAssets + cvoVisitData.after_visit" :thumbnail="true"></b-img>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label-for="description" label="Deskripsi">
                                    <b-form-textarea id="description" :rows="3" :max-rows="6"
                                        v-model="cvoVisitData.description" readonly></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>


                    </div>

                    <div v-else>
                        <loading></loading>
                    </div>
                </b-form>
            </b-card-body>
            <div slot="footer" class="text-right">
                <b-button type="button" size="sm" variant="danger" @click="back">
                    <i class="fa fa-undo"></i> Back
                </b-button>&nbsp;
            </div>
        </b-card>

    </div>
</template>

<script>
import axios from "axios";
import interfaces from "@/templates/_interfaces.js";
import * as moment from "moment";
import "moment/locale/id";
import _ from "lodash";
import loading from "@/templates/Loading.vue";

export default {
    name: "cvo-detail-activity",
    components: {
        loading
    },
    props: {
        tableDetail: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            loading: true,
            myLocation: null,
            label: '',
            urlAssets: "https://storage.googleapis.com/mbsstorage/",
            cvoVisitData: interfaces.cvo_visit_data,
            leadHistory: null,
            selectedAttachmentFile: null,
        };
    },
    notifications: {
        showErrorNotification: {
            title: "Error Title",
            message: "Messages",
            type: "error",
        },
        showInfoNotification: {
            title: "Info Title",
            message: "Messages",
            type: "info",
        },
    },
    methods: {
        init: function (activity_id) {
            this.loading = true;
            this.getCvoActivity(activity_id);
            this.isEdit = false;
        },
        uniqueId: function (param = "") {
            return _.uniqueId(param);
        },
        getCvoActivity(activity_id) {
            this.axios
                .get("web/cvo-visit/detail/" + activity_id + "/")
                .then((response) => {
                    this.cvoVisitData = response.data.data;
                })
                .catch((error) => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        back: function () {
            this.$router.go(-1);
        },
        expired: function (error, title) {
            if (error.response.status === 401) {
                localStorage.clear();
                this.$router.push({ path: "/login" });
                this.showErrorNotification({
                    title: "Token Expired",
                    message: "Your session has been expired",
                });
            } else {
                this.showErrorNotification({
                    title: title,
                    message: error.response.data.message,
                });
            }
        },
    },
    mounted() {
        let route = this.$route.path.split("/");
        this.init(route[4]);
    },
};
</script>
